import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import clientAPI from "@/api/clientAPI.js";

import RenderString from '@/components/RenderString.js';
import ComponentTree from '@/components/ComponentTree.vue';
import ChildrenTree from '@/components/ChildrenTree.vue';
import Childs from '@/components/Childs.vue';

Vue.use(VueAxios, axios)

Vue.component('RenderString', RenderString);
Vue.component('ComponentTree', ComponentTree);
Vue.component('ChildrenTree', ChildrenTree);
Vue.component('Childs', Childs);


Vue.prototype.window = window;

let registerServiceWorker = async () => {
  window.console.log('register>', window.serviceWorker)
  if ('serviceWorker' in navigator) {
    let scope = window.location.pathname // '/noq/noq-portal/'
    window.console.log(`Registrando service worker: [${scope}]`)
    window.serviceWorker = await navigator.serviceWorker.register('./sw.js', {
      scope
    });

    window.console.log('register>', window.serviceWorker)
  }
}

if (window.location) registerServiceWorker()

window.addEventListener('beforeinstallprompt', e => {
  window.console.log('PWA: confirmacion aplicacion instalable', e)
})


/**
 * Esto se usa para que los hijos que se incluyen con ChildrenSlotTemplate
 * no se envuelvan en un div, debido a la limitacion de un unico rootelement
 * por template en vuejs.
 * esto se manifiesta sobre todo al trabajar con row / col-6. Si metes un div.row > div > div.col-6
 * la css grid deja de funcionar.
 */
 Vue.directive('remove-containing-element', {
  inserted: function(el) {
    // window.console.log('many-root-elements-template>', el)
    const children = Array.from(el.children)
    const parent = el.parentElement
    if (parent) {
      children.forEach((item) => { parent.appendChild(item) })
      parent.removeChild(el)
    }
  }
});


Vue.config.productionTip = false

window.Vue = Vue;
window.api = clientAPI;
window.__ = clientAPI.get
window.___ = clientAPI.get

import _ from 'lodash';
Vue.prototype._ = _
Vue.prototype.api = clientAPI
Vue.prototype.___ = clientAPI.get

new Vue({
  render: h => h(App),
}).$mount('#app')
